import dayjs from "dayjs"
import { inject } from "vue"

/**
 * 日付を表示用に変換します
 * @param v
 * @returns
 */
export function dateFormat(v: string | Date | null): string {
  if (!v) {
    return ''
  }
  const _dayjs = inject('dayjs') as typeof dayjs
  return _dayjs(v).format('YYYY/MM/DD')
}

/**
 * 日付を表示用に変換します
 * @param v
 * @returns
 */
export function dateFormatJp(v: string | Date | null): string {
  if (!v) {
    return ''
  }
  const _dayjs = inject('dayjs') as typeof dayjs
  return _dayjs(v).format('YYYY年M月D日')
}

/**
 * 日付を短縮表示用に変換します
 * @param v
 * @returns
 */
export function dateFormatMMDD(v: string | Date | null): string {
  if (!v) {
    return ''
  }
  const _dayjs = inject('dayjs') as typeof dayjs
  return _dayjs(v).format('MM/DD')
}

/**
 * 数値を3桁のカンマ区切りとして返します
 * @param v
 * @returns
 */
export function numberFormat(v: number): string {
  if(v === 0){
    return v.toString()
  }
  return (v) ? v.toLocaleString() : ''
}

/**
 * 時間を表示用に変換します
 * @param v
 * @returns
 */
export function timeFormat(v: string | Date | null): string {
  if (!v) {
    return ''
  }
  const _dayjs = inject('dayjs') as typeof dayjs
  return _dayjs(v).format('HH:mm')
}

// 「HH:mm:ss」から「HH:mm」に変換する
export function timeToHHmm(time: string | Date | null) {
  if (!time) {
    return ''
  }
  const parsed = parseHms(time)
  if (parsed) {
    return String(parsed.hours).padStart(2, '0') + ':' + String(parsed.minutes).padStart(2, '0');
  } else {
    return ''
  }
}

// 「HH:mm:ss」から「HH時mm分」に変換する
export function timeToHHmmJpPeriod(time: string | Date | null) {
  if (!time) {
    return ''
  }
  const parsed = parseHms(time)
  if (parsed) {
    return String(parsed.hours) + '時' + String(parsed.minutes).padStart(2, '0') + '分';
  } else {
    return ''
  }
}

// 「HH:mm:ss」から「HH時間mm分」に変換する
export function timeToHHmmJp(time: string | Date | null) {
  if (!time) {
    return ''
  }
  const parsed = parseHms(time)
  if (parsed) {
    return String(parsed.hours) + '時間' + String(parsed.minutes).padStart(2, '0') + '分';
  } else {
    return ''
  }
}

function parseHms(time: string | Date) {
  if (time instanceof Date) {
    time = time.toDateString()
  }

  const times = time.split(':')
  if (times.length >= 2) {
    return {
      hours: parseInt(times[0], 10),
      minutes: parseInt(times[1], 10),
      seconds: parseInt(times[1], 10),
    }
  } else {
    return null
  }
}

/**
 * 日付が第何週のものか求めます
 * @param v
 * @returns
 */
export function howWeek(v: string | Date | null): number | null {
  if (!v) {
    return null
  }
  const date = dayjs(v)
  // (日付（n日） + 当月初日の曜日（0：日～6：土） + 6) / 7 ※切り捨て
  return Math.floor((date.date() + date.startOf('month').day() + 6) / 7)
}
